module.exports = __webpack_public_path__ + "img/zicobikelogo.116c01c8.png";